import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { deleteAllCookie } from '../shared/security/cookies';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleTime = environment.idleTimeout; // in milliseconds
  private warningTime = environment.idleWarningTime; // Show warning before logout
  private idleTimer: any;
  private warningTimer: any;

  private isIdle$ = new BehaviorSubject<boolean>(false);
  private showWarning$ = new BehaviorSubject<boolean>(false);

  // Events that should reset the idle timer
  private events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
  // private events = ['mousedown', 'keypress', 'touchstart', 'click'];

  constructor(private router: Router) {}

  // Observable to check if user is idle
  get isIdle() {
    return this.isIdle$.asObservable();
  }

  // Observable to show warning dialog
  get showWarning() {
    return this.showWarning$.asObservable();
  }

  private eventListeners: { [key: string]: EventListener } = {};

  // // Start monitoring user activity
  // startWatching() {
  //   this.events.forEach(event => {
  //     document.addEventListener(event, () => this.resetTimer(), true);
  //   });
  //   this.resetTimer();
  // }

  // Start monitoring user activity
  startWatching() {
    this.events.forEach((event) => {
      this.eventListeners[event] = () => this.onUserActivity();
      document.addEventListener(event, this.eventListeners[event], true);
    });
    this.resetTimer();
  }

  // // Stop monitoring
  // stopWatching() {
  //   this.clearTimers();
  //   this.events.forEach(event => {
  //     document.removeEventListener(event, () => this.resetTimer(), true);
  //   });
  // }

  // Stop monitoring
  stopWatching() {
    this.clearTimers();
    this.events.forEach((event) => {
      if (this.eventListeners[event]) {
        document.removeEventListener(event, this.eventListeners[event], true);
        delete this.eventListeners[event];
      }
    });
  }

  // Handle user activity - only reset if not showing warning
  private onUserActivity() {
    if (!this.showWarning$.value) {
      this.resetTimer();
    }
  }

  // Reset the idle timer
  private resetTimer() {
    this.clearTimers();
    this.isIdle$.next(false);
    this.showWarning$.next(false);

    // Set warning timer (show warning 2 minutes before logout)
    this.warningTimer = setTimeout(() => {
      this.showWarning$.next(true);
    }, this.idleTime - this.warningTime);

    // Set logout timer
    this.idleTimer = setTimeout(() => {
      this.logout();
    }, this.idleTime);
  }

  // Clear all timers
  private clearTimers() {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
    }
    if (this.warningTimer) {
      clearTimeout(this.warningTimer);
    }
  }

  // Logout user
  private logout() {
    this.isIdle$.next(true);
    this.showWarning$.next(false);
    this.clearTimers();

    // Clear user session/token
    // localStorage.removeItem('authToken');
    localStorage.clear();
    sessionStorage.clear();
    deleteAllCookie();

    // Redirect to login
    this.router.navigate(['/sign-in']);
  }

  // Manual logout (for "Stay logged in" button)
  extendSession() {
    this.resetTimer();
  }
}
